(function () {
  'use strict';

  if (window.__samTagCartImageInitialized) return;
  window.__samTagCartImageInitialized = true;

  function applyCachedImageToRow(row, imageSrc) {
    if (!(row instanceof HTMLElement) || !imageSrc) return;

    var image = row.querySelector('.cart-items__media-image');
    if (!(image instanceof HTMLImageElement)) return;
    if (image.dataset.samTagImageApplied === imageSrc) return;

    image.src = imageSrc;
    image.removeAttribute('srcset');
    image.removeAttribute('sizes');
    image.dataset.samTagImageApplied = imageSrc;
  }

  function applyCachedImages(scope) {
    var cacheApi = window.SamTagImageCache;
    if (!cacheApi || typeof cacheApi.getItemImage !== 'function') return;

    var root = scope && scope.querySelectorAll ? scope : document;
    root.querySelectorAll('tr[data-sam-tag-item="true"][data-sam-tag-cache-key]').forEach(function (row) {
      var cacheKey = row.getAttribute('data-sam-tag-cache-key');
      var imageSet = cacheKey && typeof cacheApi.getItemImages === 'function'
        ? cacheApi.getItemImages(cacheKey)
        : null;
      var imageSrc = imageSet && imageSet.front ? imageSet.front : '';
      if (!imageSrc && cacheKey) {
        imageSrc = cacheApi.getItemImage(cacheKey);
      }
      if (!imageSrc) return;
      applyCachedImageToRow(row, imageSrc);
    });
  }

  function scheduleApply(scope) {
    var run = function () {
      applyCachedImages(scope);
    };

    if (typeof window.requestAnimationFrame === 'function') {
      window.requestAnimationFrame(function () {
        window.requestAnimationFrame(run);
      });
    } else {
      window.setTimeout(run, 0);
    }

    window.setTimeout(run, 120);
  }

  var observer = new MutationObserver(function (mutations) {
    for (var i = 0; i < mutations.length; i += 1) {
      var mutation = mutations[i];
      if (!mutation.addedNodes || !mutation.addedNodes.length) continue;
      scheduleApply(document);
      break;
    }
  });

  if (document.body) {
    observer.observe(document.body, { childList: true, subtree: true });
  } else {
    document.addEventListener('DOMContentLoaded', function () {
      observer.observe(document.body, { childList: true, subtree: true });
    }, { once: true });
  }

  document.addEventListener('DOMContentLoaded', function () {
    scheduleApply(document);
  });

  document.addEventListener('cart:update', function () {
    scheduleApply(document);
  });

  window.SamTagCartImage = {
    apply: scheduleApply,
  };
})();
